import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from './components/Toast';
import { useAuthStore } from './store/useStore';
import { PENDING_ORDER_KEY } from './components/BalanceDisplay';
import MainLayout from './layouts/MainLayout';
import LoginPage from './pages/LoginPage';
import MyDances from './pages/MyDances';
import DanceDetail from './pages/DanceDetail';
import OfficialTemplates from './pages/OfficialTemplates';
import TemplateDetail from './pages/TemplateDetail';
import CreateDance from './pages/CreateDance';
import KeyframeEditor from './pages/KeyframeEditor';
import PluginSquare from './pages/PluginSquare';
import OrderManagement from './pages/OrderManagement';
import HelpCenter from './pages/HelpCenter';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
    const hasToken = typeof window !== 'undefined' && Boolean(localStorage.getItem('auth_token'));
  // const hasToken = true;
  if (!isLoggedIn && !hasToken) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

/** 兜底：未登录时清理可能残留的待处理充值订单，避免下次登录后误弹旧的成功框 */
function PendingPaymentCleanup() {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  useEffect(() => {
    const hasToken = Boolean(localStorage.getItem('auth_token'));
    if (!isLoggedIn && !hasToken) {
      localStorage.removeItem(PENDING_ORDER_KEY);
    }
  }, [isLoggedIn]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <PendingPaymentCleanup />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
          <Route index element={<Navigate to="/my-dances" replace />} />
          <Route path="my-dances" element={<MyDances />} />
          <Route path="templates" element={<OfficialTemplates />} />
          <Route path="create" element={<CreateDance />} />
          <Route path="plugins" element={<PluginSquare />} />
          <Route path="orders" element={<OrderManagement />} />
          <Route path="help" element={<HelpCenter />} />
        </Route>
        <Route path="/editor/:id" element={<ProtectedRoute><KeyframeEditor /></ProtectedRoute>} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
